export const GET_PROMOTERS_START = 'GET_PROMOTERS_START';
export const GET_PROMOTERS_SUCCESS = 'GET_PROMOTERS_SUCCESS';
export const GET_PROMOTERS_FAIL = 'GET_PROMOTERS_FAIL';

export const GET_PROMOTER_START = 'GET_PROMOTER_START';
export const GET_PROMOTER_SUCCESS = 'GET_PROMOTER_SUCCESS';
export const GET_PROMOTER_FAIL = 'GET_PROMOTER_FAIL';

export const UPDATE_PROMOTER_SUCCESS = 'UPDATE_PROMOTER_SUCCESS';

export const SET_PROMOTER_SCANBIT_COST_START = 'SET_PROMOTER_SCANBIT_COST_START';
export const SET_PROMOTER_SCANBIT_COST_SUCCESS = 'SET_PROMOTER_SCANBIT_COST_SUCCESS';
export const SET_PROMOTER_SCANBIT_COST_FAIL = 'SET_PROMOTER_SCANBIT_COST_FAIL';

export const BAN_PROMOTER_START = 'BAN_PROMOTER_START';
export const BAN_PROMOTER_SUCCESS = 'BAN_PROMOTER_SUCCESS';
export const BAN_PROMOTER_FAIL = 'BAN_PROMOTER_FAIL';

export const SIGN_IN_PROMOTER_AS_ADMIN_START = 'SIGN_IN_PROMOTER_AS_ADMIN_START';
export const SIGN_IN_PROMOTER_AS_ADMIN_SUCCESS = 'SIGN_IN_PROMOTER_AS_ADMIN_SUCCESS';
export const SIGN_IN_PROMOTER_AS_ADMIN_FAIL = 'SIGN_IN_PROMOTER_AS_ADMIN_FAIL';

export const GET_MAPS_START = 'GET_MAPS_START';
export const GET_MAPS_SUCCESS = 'GET_MAPS_SUCCESS';
export const GET_MAPS_FAIL = 'GET_MAPS_FAIL';

export const ADD_MAP_SUCCESS = 'ADD_MAP_SUCCESS';

export const UPDATE_MAP_SUCCESS = 'UPDATE_MAP_SUCCESS';

export const GET_WORKSPACE_SUCCESS = 'GET_WORKSPACE_SUCCESS';

export const UPDATE_WORKSPACE_SUCCESS = 'UPDATE_WORKSPACE_SUCCESS';
